export class ErrorCostRateModel {
  public errorCodeId: string;
  public errorCodeDescription: string;
  public errorCodeClass: string;
  public costRate: number;
  public signatureValid: boolean;
}
